import { CURRENT_ENV } from "../Utills/constants";

const slotCount = Object.keys(CURRENT_ENV).filter((key) =>
  /^LIFF_ID\d+$/.test(key)
).length;

export const gachaConfigs = [
  ...Array.from({ length: slotCount }, (_, i) => {
    const num = i + 1;
    return {
      id: num,
      name: `gacha${num}`,
      liffId: CURRENT_ENV[`LIFF_ID${num}`],
      apiBaseUrl: CURRENT_ENV[`API_BASE_URL${num}`],
      flexImage: CURRENT_ENV[`FLEX_IMAGE${num}`],
      bgClass: `app-bg${num}`,
      title: `🎰 สุ่มกาชาปอง 99฿`,
      subtitle: "ลุ้นรางวัลใหญ่!",
    };
  }),
];